import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import "./Header.css?v=2";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";

const Header = () => {
  const navigate = useNavigate();
  const { admin, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log("Dropdown state:", showDropdown);
    console.log("Admin data:", admin);
  }, [showDropdown, admin]);

  const handleLogout = () => {
    // Call logout to clear auth state
    logout();
    // Close dropdown
    setShowDropdown(false);
    // Navigate to login
    navigate("/admin/login");
  };

  const handleThemeToggle = () => {
    toggleTheme();
  };

  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <header className="admin-header">
      <div className="header-gradient"></div>

      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">
            <span className="title-icon">⚡</span>
            LICO Admin
          </h1>
        </div>

        <div className="header-right">
          {/* Theme Toggle */}
          <button
            className="theme-toggle-btn"
            onClick={handleThemeToggle}
            aria-label="Toggle theme"
          >
            <span className="theme-icon">{theme === "dark" ? "🌞" : "🌙"}</span>
          </button>

          {/* User Menu */}
          <div className="user-menu" ref={dropdownRef}>
            <button
              className="user-button"
              onClick={() => {
                console.log("Button clicked, current state:", showDropdown);
                setShowDropdown(!showDropdown);
              }}
              aria-label="User menu"
              aria-expanded={showDropdown}
            >
              <div className="user-avatar">
                {admin?.name ? getInitials(admin.name) : "AD"}
                <div className="avatar-ring"></div>
              </div>
              <div className="user-info-preview">
                <span className="user-name">{admin?.name || "Admin"}</span>
                <span className="user-role-badge">
                  {admin?.role || "admin"}
                </span>
              </div>
              <span className={`dropdown-arrow ${showDropdown ? "open" : ""}`}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M4 6L8 10L12 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>

            {/* Remove the conditional rendering wrapper */}
            <div className={`dropdown-menu ${showDropdown ? "show" : ""}`}>
              <div className="dropdown-header">
                <div className="dropdown-avatar-large">
                  {admin?.name ? getInitials(admin.name) : "AD"}
                  <div className="avatar-glow"></div>
                </div>
                <div className="dropdown-user-info">
                  <p className="dropdown-user-name">{admin?.name || "Admin"}</p>
                  <p className="dropdown-user-email">{admin?.email || ""}</p>
                  <span className="dropdown-user-role">
                    {admin?.role || "admin"}
                  </span>
                </div>
              </div>

              <div className="dropdown-divider"></div>

              <button
                className="dropdown-item logout-item"
                onClick={handleLogout}
              >
                <span className="item-icon">🚪</span>
                <span>Logout</span>
                <span className="item-arrow">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
